export default __webpack_public_path__ + "static/Dunbar-3962ccc1a8b8f8d128760217c17e4d4e.png";